<template>
  <div class="dk-estilo-page">

    <!-- ── Painel de Configurações ───────────────────── -->
    <aside class="dk-estilo-panel">

      <!-- Voltar ao vídeo -->
      <button class="dk-sidebar-back" @click="$router.push(`/player/${vslId}`)">
        <feather-icon icon="ArrowLeftIcon" size="14" class="dk-sidebar-back__icon" />
        <span>Voltar ao vídeo</span>
      </button>

      <div class="dk-sidebar-divider" />

      <!-- Nav de personalização -->
      <nav class="dk-sidebar-subnav">
        <router-link :to="`/player/${vslId}/estilo`" class="dk-subnav-item dk-subnav-item--active">
          <feather-icon icon="LayersIcon" size="14" />
          <span>Estilo</span>
        </router-link>
        <router-link :to="`/player/${vslId}/thumbnails`" class="dk-subnav-item">
          <feather-icon icon="ImageIcon" size="14" />
          <span>Thumbnails</span>
        </router-link>
        <router-link :to="`/player/${vslId}/AutoPlayHibrido`" class="dk-subnav-item">
          <feather-icon icon="PlayCircleIcon" size="14" />
          <span>Play Inicial</span>
        </router-link>
        <router-link :to="`/player/${vslId}/ProgressoInteligente`" class="dk-subnav-item">
          <feather-icon icon="ActivityIcon" size="14" />
          <span>Progresso</span>
        </router-link>
        <router-link :to="`/player/${vslId}/ContinuarAssistindo`" class="dk-subnav-item">
          <feather-icon icon="MonitorIcon" size="14" />
          <span>Continuar Assistindo</span>
        </router-link>
        <router-link :to="`/player/${vslId}/botoes-acoes`" class="dk-subnav-item">
          <feather-icon icon="ZapIcon" size="14" />
          <span>Botões de Ação</span>
        </router-link>
      </nav>

      <div class="dk-sidebar-divider" />

      <!-- Header do painel -->
      <div class="dk-estilo-panel__head">
        <div class="dk-estilo-panel__title-row">
          <div class="dk-estilo-panel__icon">
            <feather-icon icon="LayersIcon" size="16" />
          </div>
          <div>
            <h3 class="dk-estilo-panel__title">Estilo do Player</h3>
            <p class="dk-estilo-panel__subtitle">Aparência e controles</p>
          </div>
        </div>
      </div>

      <div v-if="control && control[0]" class="dk-estilo-panel__body">

        <!-- Seção: Aparência -->
        <div class="dk-section">
          <div class="dk-section__label">
            <feather-icon icon="DropletIcon" size="12" class="mr-25" />
            Aparência
          </div>

          <div class="dk-color-row">
            <div class="dk-color-item">
              <label class="dk-color-item__label">Background</label>
              <div class="dk-color-item__swatch-wrap">
                <input
                  id="cor-background-estilo"
                  v-model="control[0].controls_back_color"
                  type="color"
                  class="dk-color-input"
                />
                <span class="dk-color-item__value">{{ control[0].controls_back_color }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Ações (logo após cor) -->
        <div class="dk-estilo-panel__actions">
          <button id="salvar-estilo" class="dk-btn-save" @click="updateSubmit">
            <feather-icon icon="CheckIcon" size="14" class="mr-50" />
            Salvar Alteracoes
          </button>
          <router-link :to="`/player/${vslId}/customizacao`" class="dk-btn-cancel">
            Voltar
          </router-link>
        </div>

        <div class="dk-divider" />

        <!-- Seção: Barra de progresso -->
        <div class="dk-section">
          <div class="dk-section__label">
            <feather-icon icon="SlidersIcon" size="12" class="mr-25" />
            Controles Visíveis
          </div>

          <div class="dk-toggle-list">
            <label class="dk-toggle-item">
              <span class="dk-toggle-item__text">
                <span class="dk-toggle-item__name">Botão Play Pequeno</span>
              </span>
              <div class="dk-toggle-wrap">
                <input
                  id="play-pqueno-estilo"
                  v-model="control[0].controls_bt_small_player"
                  type="checkbox"
                  :true-value="1"
                  :false-value="0"
                  class="dk-toggle-input"
                />
                <span class="dk-toggle-slider" />
              </div>
            </label>

            <label class="dk-toggle-item">
              <span class="dk-toggle-item__text">
                <span class="dk-toggle-item__name">Picture-in-Picture</span>
              </span>
              <div class="dk-toggle-wrap">
                <input
                  id="Picture-in-picture-estilo"
                  v-model="control[0].controls_picture_in_picture"
                  type="checkbox"
                  :true-value="1"
                  :false-value="0"
                  class="dk-toggle-input"
                />
                <span class="dk-toggle-slider" />
              </div>
            </label>

            <label class="dk-toggle-item">
              <span class="dk-toggle-item__text">
                <span class="dk-toggle-item__name">Volume</span>
              </span>
              <div class="dk-toggle-wrap">
                <input
                  id="Volume-estilo"
                  v-model="control[0].controls_video_vol"
                  type="checkbox"
                  :true-value="1"
                  :false-value="0"
                  class="dk-toggle-input"
                />
                <span class="dk-toggle-slider" />
              </div>
            </label>

            <label class="dk-toggle-item">
              <span class="dk-toggle-item__text">
                <span class="dk-toggle-item__name">Tela Cheia</span>
              </span>
              <div class="dk-toggle-wrap">
                <input
                  id="Tela-Cheia-estilo"
                  v-model="control[0].controls_bt_screem"
                  type="checkbox"
                  :true-value="1"
                  :false-value="0"
                  class="dk-toggle-input"
                />
                <span class="dk-toggle-slider" />
              </div>
            </label>

            <label class="dk-toggle-item">
              <span class="dk-toggle-item__text">
                <span class="dk-toggle-item__name">Avançar 10s</span>
              </span>
              <div class="dk-toggle-wrap">
                <input
                  id="Avançar-10s-estilo"
                  v-model="control[0].controls_avan_10s"
                  type="checkbox"
                  :true-value="1"
                  :false-value="0"
                  class="dk-toggle-input"
                />
                <span class="dk-toggle-slider" />
              </div>
            </label>

            <label class="dk-toggle-item">
              <span class="dk-toggle-item__text">
                <span class="dk-toggle-item__name">Voltar 10s</span>
              </span>
              <div class="dk-toggle-wrap">
                <input
                  id="Voltar-10s-estilo"
                  v-model="control[0].controls_retro_10s"
                  type="checkbox"
                  :true-value="1"
                  :false-value="0"
                  class="dk-toggle-input"
                />
                <span class="dk-toggle-slider" />
              </div>
            </label>
          </div>
        </div>

        <div class="dk-divider" />

        <!-- Seção: Legenda Automática (IA) -->
        <div class="dk-section">
          <div class="dk-section__label">
            <feather-icon icon="TypeIcon" size="12" class="mr-25" />
            Legenda Automática (IA)
          </div>

          <div class="dk-toggle-list">
            <label class="dk-toggle-item">
              <span class="dk-toggle-item__text">
                <span class="dk-toggle-item__name">Exibir legenda no player</span>
              </span>
              <div class="dk-toggle-wrap">
                <input
                  v-model="control[0].controls_subtitle_enabled"
                  type="checkbox"
                  :true-value="1"
                  :false-value="0"
                  class="dk-toggle-input"
                />
                <span class="dk-toggle-slider" />
              </div>
            </label>
          </div>

          <!-- Status + Botão gerar -->
          <div class="dk-subtitle-actions">
            <div v-if="subtitleStatus === 'done'" class="dk-subtitle-badge dk-subtitle-badge--ok">
              <feather-icon icon="CheckCircleIcon" size="12" class="mr-25" />
              Legenda gerada
            </div>
            <div v-else-if="subtitleStatus === 'processing'" class="dk-subtitle-badge dk-subtitle-badge--loading">
              <div class="dk-mini-spinner mr-25" />
              Gerando legenda...
            </div>
            <div v-else-if="subtitleStatus === 'error'" class="dk-subtitle-badge dk-subtitle-badge--error">
              <feather-icon icon="AlertCircleIcon" size="12" class="mr-25" />
              Erro: {{ subtitleError }}
            </div>
            <div v-else class="dk-subtitle-badge dk-subtitle-badge--empty">
              <feather-icon icon="InfoIcon" size="12" class="mr-25" />
              Nenhuma legenda gerada
            </div>

            <button
              class="dk-btn-generate"
              :disabled="subtitleStatus === 'processing'"
              @click="gerarLegenda"
            >
              <feather-icon :icon="subtitleStatus === 'done' ? 'RefreshCwIcon' : 'MicIcon'" size="13" class="mr-25" />
              {{ subtitleStatus === 'done' ? 'Regerar legenda' : 'Gerar legenda com IA' }}
            </button>
          </div>

          <!-- Cores da legenda -->
          <div v-if="control[0].controls_subtitle_enabled" class="dk-subtitle-colors">
            <div class="dk-color-row">
              <div class="dk-color-item">
                <label class="dk-color-item__label">Cor do texto</label>
                <div class="dk-color-item__swatch-wrap">
                  <input
                    v-model="control[0].controls_subtitle_text_color"
                    type="color"
                    class="dk-color-input"
                  />
                  <span class="dk-color-item__value">{{ control[0].controls_subtitle_text_color || '#FFFFFF' }}</span>
                </div>
              </div>
              <div class="dk-color-item">
                <label class="dk-color-item__label">Cor do fundo</label>
                <div class="dk-color-item__swatch-wrap">
                  <input
                    v-model="control[0].controls_subtitle_bg_color"
                    type="color"
                    class="dk-color-input"
                  />
                  <span class="dk-color-item__value">{{ control[0].controls_subtitle_bg_color || '#000000' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="dk-divider" />

      </div>

      <!-- Loading skeleton -->
      <div v-else class="dk-estilo-panel__loading">
        <div class="dk-skeleton dk-skeleton--h24 w-75 mb-1" />
        <div class="dk-skeleton dk-skeleton--h16 w-50 mb-2" />
        <div class="dk-skeleton dk-skeleton--h40" />
        <div class="dk-skeleton dk-skeleton--h40 mt-1" />
        <div class="dk-skeleton dk-skeleton--h40 mt-1" />
      </div>
    </aside>

    <!-- ── Área do Player ─────────────────────────────── -->
    <main class="dk-estilo-main">

      <div class="dk-player-badge-row">
        <span class="dk-player-badge">
          <feather-icon icon="EyeIcon" size="11" class="mr-25" />
          Preview em tempo real
        </span>
      </div>

      <player-preview-iframe
        :vsl-id="vslId"
        :thumb-src="dadosVideo.thumb && dadosVideo.thumb.thumbStart || ''"
        :orientation="dadosVideo.orientation || 'Horizontal'"
      />

      <div class="dk-player-tip">
        <feather-icon icon="InfoIcon" size="12" class="mr-25" />
        As alterações são refletidas no player em tempo real
      </div>
    </main>
  </div>
</template>

<script>
import { ControlsService } from '@/services/Controls'
import PlayerPreviewIframe from '@/components/player/PlayerPreviewIframe.vue'

export default {
  components: { PlayerPreviewIframe },
  data() {
    return {
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend',
      vslId: this.$route.params.vslId,
      loading: false,
      errorMessage: null,
      playx: 'true',
      control: [],
      dadosVideo: { thumb: {}, autoPlayer: {}, barra: {}, URL: '' },
      subtitleStatus: 'none',
      subtitleError: '',
      subtitlePollTimer: null,
    }
  },
  computed: {
    getControls() {
      return this.control
    },
  },
  async created() {
    try {
      this.loading = true
      const response = await ControlsService.getControlVSL_Id(this.vslId)
      this.control = response.data
      // Garante defaults de legenda caso colunas ainda não existam
      if (this.control && this.control[0]) {
        const c = this.control[0]
        if (c.controls_subtitle_enabled === undefined) c.controls_subtitle_enabled = 0
        if (!c.controls_subtitle_text_color) c.controls_subtitle_text_color = '#FFFFFF'
        if (!c.controls_subtitle_bg_color) c.controls_subtitle_bg_color = '#000000'
      }
      this.loading = false
      this.checkSubtitleStatus()
    } catch (error) {
      this.errorMessage = error
      this.loading = false
    }
  },
  beforeDestroy() {
    if (this.subtitlePollTimer) clearInterval(this.subtitlePollTimer)
  },
  beforeMount() {
    this.jsonPersonalizado()
  },
  methods: {
    jsonPersonalizado() {
      const url = `${this.VUE_APP_HOST_API_BACKEND}/vslsInner/${this.vslId}`
      fetch(url)
        .then(response => response.json())
        .then(data => {
          if (data.status == '1') {
            this.dadosVideo = data.json.find(item => String(item.id) === String(this.vslId))
          }
        })
    },
    updateSubmit() {
      if (!this.control || !this.control[0]) return
      const c = this.control[0]
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/control/${this.vslId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          controls_bt_big_player: c.controls_bt_big_player,
          controls_bt_small_player: c.controls_bt_small_player,
          controls_progress_bar: c.controls_progress_bar,
          controls_video_time: c.controls_video_time,
          controls_video_vol: c.controls_video_vol,
          controls_bt_screem: c.controls_bt_screem,
          controls_avan_10s: c.controls_avan_10s,
          controls_retro_10s: c.controls_retro_10s,
          controls_back_color: c.controls_back_color,
          controls_main_color: c.controls_main_color,
          controls_picture_in_picture: c.controls_picture_in_picture,
          controls_subtitle_enabled: c.controls_subtitle_enabled,
          controls_subtitle_text_color: c.controls_subtitle_text_color,
          controls_subtitle_bg_color: c.controls_subtitle_bg_color,
          id_vsl: this.vslId,
        }),
      })
        .then(() => {
          this.$message({ type: 'success', message: 'Salvo com sucesso' })
        })
        .catch(err => console.error(err))
    },
    togglePlay() {
      const player = document.querySelector('.player')
      if (!player) return
      const video = player.querySelector('.player_my_video')
      const togglePausePlay = player.querySelector('.playpause')
      const togglePausePlaybg = player.querySelector('.playpausebg')
      if (video.paused) {
        video.play()
        togglePausePlay && togglePausePlay.setAttribute('hidden', '')
        togglePausePlaybg && togglePausePlaybg.setAttribute('hidden', '')
        video.muted = false
      } else {
        video.pause()
        togglePausePlay && togglePausePlay.removeAttribute('hidden')
        togglePausePlaybg && togglePausePlaybg.removeAttribute('hidden')
      }
    },
    avancar() {
      const video = document.querySelector('.player_my_video')
      if (video) video.currentTime += 10
    },
    retroceder() {
      const video = document.querySelector('.player_my_video')
      if (video) video.currentTime -= 10
    },

    async checkSubtitleStatus() {
      try {
        const { data } = await this.$http.get(`subtitles/${this.vslId}`)
        this.subtitleStatus = data.status || 'none'
        this.subtitleError = data.error_msg || ''
        if (data.status === 'processing') {
          this.startSubtitlePoll()
        }
      } catch { this.subtitleStatus = 'none' }
    },

    startSubtitlePoll() {
      if (this.subtitlePollTimer) return
      this.subtitlePollTimer = setInterval(async () => {
        try {
          const { data } = await this.$http.get(`subtitles/${this.vslId}`)
          this.subtitleStatus = data.status || 'none'
          this.subtitleError = data.error_msg || ''
          if (data.status !== 'processing') {
            clearInterval(this.subtitlePollTimer)
            this.subtitlePollTimer = null
          }
        } catch { /* ignora */ }
      }, 5000)
    },

    async gerarLegenda() {
      try {
        this.subtitleStatus = 'processing'
        await this.$http.post(`subtitles/${this.vslId}/generate`)
        this.$message({ type: 'info', message: 'Geração de legenda iniciada — pode levar alguns minutos' })
        this.startSubtitlePoll()
      } catch (e) {
        this.subtitleStatus = 'error'
        this.subtitleError = e.response?.data?.error || 'Falha ao iniciar geração'
        this.$message({ type: 'error', message: this.subtitleError })
      }
    },
    toggleFullScreen() {
      const player = document.querySelector('.player')
      if (!document.fullscreenElement) {
        player && player.requestFullscreen && player.requestFullscreen()
      } else {
        document.exitFullscreen && document.exitFullscreen()
      }
    },
    handleProgress() {
      const player = document.querySelector('.player')
      if (!player) return
      const video = player.querySelector('.player_my_video')
      const progressBar = player.querySelector('.progress_my_filled')
      const toggleEndedbg = player.querySelector('.playEndedbg')
      const togglePausePlay = player.querySelector('.playpause')
      if (!video || !progressBar) return
      if (video.ended) {
        toggleEndedbg && toggleEndedbg.removeAttribute('hidden')
        togglePausePlay && togglePausePlay.removeAttribute('hidden')
      }
      const pct = (video.currentTime / (video.duration || 1)) * 100
      progressBar.style.flexBasis = `${Math.min(pct, 100)}%`
    },
  },
}
</script>

<style lang="scss" scoped>
/* ─── Variáveis ──────────────────────────────────── */
$navy:    #0D3349;
$orange:  #E86A10;
$border:  rgba(255,255,255,0.09);
$bg:      rgba(255,255,255,0.04);
$text:    #e2e8f0;
$muted:   rgba(255,255,255,0.4);
$white:   #ffffff;
$dark:    #0a1520;

/* ─── Layout raiz ────────────────────────────────── */
.dk-estilo-page {
  display: flex;
  gap: 24px;
  min-height: calc(100vh - 140px);
  align-items: flex-start;
  padding: 8px 0 40px;
}

/* ─── Painel de configurações ─────────────────────── */
.dk-estilo-panel {
  width: 280px;
  flex-shrink: 0;
  background: rgba(255,255,255,0.05);
  border: 1px solid $border;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.3);
  overflow: hidden;
  position: sticky;
  top: 80px;
}

/* ── Botão voltar ── */
.dk-sidebar-back {
  display: flex; align-items: center; gap: 8px;
  padding: 14px 16px; width: 100%; border: none; background: none;
  cursor: pointer; font-family: inherit; font-size: 13px;
  font-weight: 600; color: $text; transition: color 0.15s;
  &:hover { color: $orange; }
}
.dk-sidebar-back__icon { color: $orange; }
.dk-sidebar-divider { height: 1px; background: rgba(255,255,255,0.07); }

/* ── Sub-navegação ── */
.dk-sidebar-subnav {
  display: flex; flex-direction: column; padding: 8px;
}
.dk-subnav-item {
  display: flex; align-items: center; gap: 10px;
  padding: 9px 12px; border-radius: 8px;
  font-size: 12.5px; font-weight: 600; color: $muted;
  text-decoration: none; transition: all 0.15s;
  &:hover { background: rgba(255,255,255,0.07); color: $text; }
}
.dk-subnav-item--active,
.dk-subnav-item.router-link-exact-active {
  background: rgba($orange, 0.12); color: $orange;
}

.dk-estilo-panel__head {
  padding: 18px 20px 14px;
  border-bottom: 1px solid $border;
  background: rgba(255,255,255,0.03);
}
.dk-estilo-panel__title-row {
  display: flex;
  align-items: center;
  gap: 12px;
}
.dk-estilo-panel__icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba($orange, 0.1);
  color: $orange;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.dk-estilo-panel__title {
  font-size: 14px;
  font-weight: 700;
  color: #e2e8f0;
  margin: 0;
  line-height: 1.2;
}
.dk-estilo-panel__subtitle {
  font-size: 11px;
  color: $muted;
  margin: 2px 0 0;
}

.dk-estilo-panel__body {
  padding: 0;
}
.dk-estilo-panel__loading {
  padding: 20px;
}

/* ─── Seções ──────────────────────────────────────── */
.dk-section {
  padding: 16px 20px;
}
.dk-section__label {
  display: flex;
  align-items: center;
  font-size: 10.5px;
  font-weight: 700;
  color: $muted;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  margin-bottom: 12px;
}
.dk-divider { height: 1px; background: $border; }

/* ─── Color picker ────────────────────────────────── */
.dk-color-row { display: flex; flex-direction: column; gap: 12px; }
.dk-color-item { display: flex; flex-direction: column; gap: 6px; }
.dk-color-item__label { font-size: 12px; font-weight: 600; color: $text; }
.dk-color-item__swatch-wrap { display: flex; align-items: center; gap: 10px; }
.dk-color-input {
  width: 44px;
  height: 32px;
  border: 2px solid rgba(255,255,255,0.15);
  border-radius: 8px;
  padding: 2px;
  cursor: pointer;
  outline: none;
  background: none;
  transition: border-color 0.15s;
  &:hover { border-color: $orange; }
}
.dk-color-item__value {
  font-size: 12px;
  font-weight: 600;
  color: $muted;
  font-family: 'Courier New', monospace;
  text-transform: uppercase;
}

/* ─── Toggle list ─────────────────────────────────── */
.dk-toggle-list { display: flex; flex-direction: column; gap: 4px; }
.dk-toggle-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  cursor: pointer;
  border-bottom: 1px solid rgba(255,255,255,0.06);
  &:last-child { border-bottom: none; }
  &:hover .dk-toggle-item__name { color: #fff; }
}
.dk-toggle-item__text { display: flex; flex-direction: column; gap: 1px; }
.dk-toggle-item__name { font-size: 13px; font-weight: 500; color: $text; transition: color 0.15s; }

/* Toggle switch estilo iOS */
.dk-toggle-wrap {
  position: relative;
  width: 40px;
  height: 22px;
  flex-shrink: 0;
}
.dk-toggle-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.dk-toggle-slider {
  position: absolute;
  inset: 0;
  background: rgba(255,255,255,0.15);
  border-radius: 34px;
  transition: background 0.2s;
  cursor: pointer;

  &::before {
    content: '';
    position: absolute;
    height: 16px;
    width: 16px;
    left: 3px;
    bottom: 3px;
    background: var(--dk-bg-card, white);
    border-radius: 50%;
    transition: transform 0.2s;
    box-shadow: 0 1px 4px rgba(0,0,0,0.2);
  }
}
.dk-toggle-input:checked + .dk-toggle-slider {
  background: $orange;
  &::before { transform: translateX(18px); }
}

/* ─── Ações ───────────────────────────────────────── */
.dk-estilo-panel__actions {
  padding: 16px 20px;
  display: flex;
  flex-direction: row;
  gap: 8px;
}
.dk-btn-save {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 11px 16px;
  background: $orange;
  color: $white;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.15s;
  white-space: nowrap;
  &:hover { opacity: 0.9; }
}
.dk-btn-cancel {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  padding: 10px 20px;
  background: rgba(255,255,255,0.05);
  border: 1px solid $border;
  border-radius: 10px;
  font-size: 13px;
  color: $muted;
  text-decoration: none;
  white-space: nowrap;
  transition: all 0.15s;
  &:hover { border-color: rgba(255,255,255,0.3); color: $text; text-decoration: none; }
}

/* ─── Skeleton loading ────────────────────────────── */
.dk-skeleton {
  background: linear-gradient(90deg, rgba(255,255,255,0.06) 25%, rgba(255,255,255,0.1) 50%, rgba(255,255,255,0.06) 75%);
  background-size: 200% 100%;
  animation: dk-shimmer 1.5s infinite;
  border-radius: 8px;
}
.dk-skeleton--h16 { height: 16px; }
.dk-skeleton--h24 { height: 24px; }
.dk-skeleton--h40 { height: 40px; }
@keyframes dk-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
.w-75 { width: 75%; }
.w-50 { width: 50%; }
.mb-1 { margin-bottom: 8px; }
.mb-2 { margin-bottom: 16px; }
.mt-1 { margin-top: 8px; }

/* ─── Área do player ──────────────────────────────── */
.dk-estilo-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.dk-player-badge-row { display: flex; }
.dk-player-badge {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 600;
  color: $muted;
  background: rgba(255,255,255,0.05);
  border: 1px solid $border;
  border-radius: 20px;
  padding: 4px 12px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.dk-player-wrap {
  position: relative;
  width: 100%;
  background: $dark;
  border-radius: 14px;
  overflow: hidden;
  box-shadow:
    0 4px 6px rgba(0,0,0,0.07),
    0 12px 40px rgba($navy, 0.18),
    inset 0 0 0 1px rgba(255,255,255,0.04);
}
.dk-player-video {
  width: 100%;
  height: 450px;
  display: block;
  object-fit: contain;
  background: $dark;
}

/* Controles */
.dk-player-controls {
  display: flex;
  flex-wrap: wrap;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 20;
  background: linear-gradient(to top, rgba(0,0,0,0.65) 0%, transparent 100%);
  border-radius: 0 0 14px 14px;
  padding: 8px 4px 4px;
  transform: translateY(100%);
  transition: transform 0.25s;
  > * { flex: 1; }
}
.dk-player-wrap:hover .dk-player-controls {
  transform: translateY(0);
}

.progress {
  flex: 10;
  position: relative;
  display: flex;
  flex-basis: 100%;
  height: 3px;
  background: rgba(0, 0, 0, .25);
  cursor: pointer;
  transition: height .3s;
  &:hover { height: 5px; }
}
.progress_my_filled {
  flex: 0;
  flex-basis: 0%;
  background: $orange;
  transition: flex-basis 0.1s linear;
}

.player_my_button {
  background: none;
  border: 0;
  color: white;
  text-align: center;
  outline: 0;
  padding: 8px 12px;
  cursor: pointer;
  max-width: 50px;
  opacity: 0.85;
  transition: opacity 0.15s;
  &:hover { opacity: 1; }
}
.fullscreenbtn { margin-left: auto; max-width: 50px; }
.button_volume  { max-width: 50px; }
.PictureInPicture { max-width: 50px; }

/* Play/pause overlay */
.playpause {
  border-radius: 50%;
  background-image: url(../img/play.svg);
  background-repeat: no-repeat;
  width: 80px;
  height: 80px;
  position: absolute;
  inset: 0;
  margin: auto;
  background-size: contain;
  background-position: center;
  cursor: pointer;
  z-index: 10;
  opacity: 1;
  transition: opacity 0.3s;
  &[hidden] { opacity: 0; pointer-events: none; }
}

/* Thumbnails bg */
.playpausebg,
.playEndedbg {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: absolute;
  inset: 0;
  z-index: 5;
  opacity: 1;
  transition: opacity 0.4s;
  &[hidden] { opacity: 0; }
}

/* Dica */
.dk-player-tip {
  display: flex;
  align-items: center;
  font-size: 11.5px;
  color: $muted;
  padding: 0 4px;
}

/* ─── Legenda (IA) ─────────────────────────────── */
.dk-subtitle-actions {
  display: flex; align-items: center; gap: 10px;
  flex-wrap: wrap; margin-top: 12px;
}
.dk-subtitle-badge {
  display: inline-flex; align-items: center;
  font-size: 11px; font-weight: 600;
  padding: 5px 12px; border-radius: 8px;
}
.dk-subtitle-badge--ok   { background: rgba(16,185,129,0.15); color: #34d399; }
.dk-subtitle-badge--loading { background: rgba(251,191,36,0.15); color: #fbbf24; }
.dk-subtitle-badge--error { background: rgba(248,113,113,0.15); color: #f87171; }
.dk-subtitle-badge--empty { background: rgba(255,255,255,0.07); color: rgba(255,255,255,0.4); }

.dk-btn-generate {
  display: inline-flex; align-items: center;
  padding: 7px 16px; border-radius: 8px; border: none; cursor: pointer;
  background: #E86A10; color: #fff;
  font-size: 12px; font-weight: 700; font-family: inherit;
  transition: opacity 0.2s;
}
.dk-btn-generate:hover:not(:disabled) { opacity: 0.85; }
.dk-btn-generate:disabled { opacity: 0.4; cursor: not-allowed; }

.dk-subtitle-colors { margin-top: 14px; }

.dk-mini-spinner {
  width: 12px; height: 12px; border-radius: 50%;
  border: 2px solid #fde68a; border-top-color: #d97706;
  animation: dkSpin 0.7s linear infinite; display: inline-block;
}
@keyframes dkSpin { to { transform: rotate(360deg); } }
</style>
